import React, { useState } from "react";
import CloseIcon from "../../../../../assets/images/icons/CloseIcon";
import SmallScreenIcon from "../../../../../assets/images/icons/SmallScreenIcon";
import MiniPlayer from "../MiniPlayer/MiniPlayer";
import { VideoPlayerModalStyle } from "./VideoPlayerModal.style";

const VideoPlayerModal = ({ section, setSection }: any) => {
  const [miniPlayerSection, setMiniPlayerSection] = useState<any>();

  const backToFullScreen = () => {
    setMiniPlayerSection(null);
    setSection(miniPlayerSection);
  };
  return (
    <>
      {section && (
        <VideoPlayerModalStyle>
          <div className="video">
            <div className="top">
              <h4 className="title">{section.name}</h4>
              <div className="close" onClick={() => setSection(null)}>
                <CloseIcon />
              </div>
            </div>
            <div className="body">
              <iframe
                width="100%"
                height="315"
                src={section.url}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="footer">
              <span
                onClick={() => {
                  setMiniPlayerSection(section);
                  setSection(null);
                }}
              >
                <SmallScreenIcon />
              </span>
            </div>
          </div>
        </VideoPlayerModalStyle>
      )}
      {miniPlayerSection && (
        <MiniPlayer
          section={miniPlayerSection}
          backToFullScreen={backToFullScreen}
          setMiniPlayerSection={setMiniPlayerSection}
        />
      )}
    </>
  );
};

export default VideoPlayerModal;
